import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CallRecordsDatabaseEntriesInfo, JobStatus } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class CallRecordsDatabaseEntriesResource {
  private _http = inject(HttpClient);

  private _baseUrl = '/services/microsoft/reporting/tenants';

  getInfo(tenantId: string): Observable<CallRecordsDatabaseEntriesInfo> {
    return this._http.get<CallRecordsDatabaseEntriesInfo>(
      `${this._baseUrl}/${tenantId}/call-records-database-entries/info`,
    );
  }

  getStatus(tenantId: string): Observable<JobStatus> {
    return this._http.get<JobStatus>(`${this._baseUrl}/${tenantId}/call-records-database-entries/status`);
  }

  refresh(tenantId: string): Observable<void> {
    return this._http.post<void>(`${this._baseUrl}/${tenantId}/call-records-database-entries/refresh`, null);
  }
}
